import React, { useState } from 'react';
import { storeGetOrDefault, storeSet, DEF_NAV } from '../../store';
import '../admin.css';

const Toast = ({ msg, type }) => msg ? <div className={`adm-toast adm-toast-${type}`}>{msg}</div> : null;

const NavAdmin = () => {
  const [items, setItems] = useState(() => storeGetOrDefault('navItems', DEF_NAV));
  const [mode, setMode]   = useState(null);
  const [form, setForm]   = useState({ id: null, label: '', href: '' });
  const [toast, setToast] = useState({ msg: '', type: 'success' });

  const showToast = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast({ msg: '', type: 'success' }), 3000); };
  const save      = (list) => { setItems(list); storeSet('navItems', list); };

  const openAdd = () => { setForm({ id: null, label: '', href: '' }); setMode('add'); };
  const openEdit = (item) => { setForm({ ...item }); setMode('edit'); };
  const close   = () => setMode(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.label.trim() || !form.href.trim()) return showToast('Label and link are required.', 'error');
    if (mode === 'add') {
      save([...items, { ...form, id: Date.now() }]);
      showToast('Menu item added!');
    } else {
      save(items.map(n => n.id === form.id ? { ...form } : n));
      showToast('Menu item updated!');
    }
    close();
  };

  const del    = (id) => { if (window.confirm('Remove this nav item?')) { save(items.filter(n => n.id !== id)); showToast('Removed.', 'info'); } };
  const toggle  = (id) => { save(items.map(n => n.id === id ? { ...n, disabled: !n.disabled } : n)); };
  const move = (idx, dir) => {
    const list = [...items]; const swap = idx + dir;
    if (swap < 0 || swap >= list.length) return;
    [list[idx], list[swap]] = [list[swap], list[idx]];
    save(list);
  };

  const resetDefault = () => { if (window.confirm('Reset navigation to default? All custom items will be lost.')) { save(DEF_NAV); showToast('Navigation reset to defaults.'); } };

  const field = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  return (
    <div className='adm-page'>
      <Toast {...toast} />
      <div className='adm-header'>
        <div>
          <h1 className='adm-title'>Navigation Menu</h1>
          <p className='adm-subtitle'>Control the order and links in the top navigation bar</p>
        </div>
        <div className='adm-actions'>
          <button className='adm-btn adm-btn-ghost adm-btn-sm' onClick={resetDefault}>Reset to Default</button>
          <button className='adm-btn adm-btn-primary' onClick={openAdd}>+ Add Item</button>
        </div>
      </div>

      <div style={{ maxWidth: 640 }}>
        {items.map((item, idx) => (
          <div className='adm-nav-item' key={item.id}>
            <div className='adm-order-col'>
              <button className='adm-order-btn' onClick={() => move(idx, -1)} disabled={idx === 0}>▲</button>
              <button className='adm-order-btn' onClick={() => move(idx, 1)}  disabled={idx === items.length - 1}>▼</button>
            </div>
            <div className='adm-nav-drag'>☰</div>
            <div style={{ flex: 1, opacity: item.disabled ? 0.45 : 1 }}>
              <div className='adm-nav-label' style={{ textDecoration: item.disabled ? 'line-through' : 'none' }}>{item.label}</div>
              <div className='adm-nav-href'>{item.href}</div>
            </div>
            <div className='adm-actions'>
              <button
                onClick={() => toggle(item.id)}
                style={{
                  padding: '4px 12px', borderRadius: 20, border: 'none', cursor: 'pointer',
                  fontWeight: 700, fontSize: '.75rem',
                  background: item.disabled ? '#fee2e2' : '#dcfce7',
                  color: item.disabled ? '#dc2626' : '#16a34a',
                }}
                title={item.disabled ? 'Click to show in navbar' : 'Click to hide from navbar'}
              >
                {item.disabled ? 'Hidden' : 'Visible'}
              </button>
              <button className='adm-btn adm-btn-outline adm-btn-sm' onClick={() => openEdit(item)}>Edit</button>
              <button className='adm-btn adm-btn-danger  adm-btn-sm' onClick={() => del(item.id)}>Remove</button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className='adm-empty'><div className='adm-empty-icon'>🔗</div><p>No nav items. Add one above.</p></div>}
      </div>

      <div style={{ marginTop: 16, padding: '14px 18px', background: '#fef9c3', borderRadius: 8, border: '1px solid #fde68a', fontSize: '.83rem', color: '#854d0e', maxWidth: 640 }}>
        ⚠️ <strong>Note:</strong> The navigation reflects these items live. Internal paths start with <code>/</code> (e.g. <code>/products</code>). External links use <code>https://</code>.
      </div>

      {mode && (
        <div className='adm-modal-overlay' onClick={e => e.target === e.currentTarget && close()}>
          <div className='adm-modal'>
            <div className='adm-modal-header'>
              <h2 className='adm-modal-title'>{mode === 'add' ? 'Add Nav Item' : 'Edit Nav Item'}</h2>
              <button className='adm-close-btn' onClick={close}>✕</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className='adm-modal-body'>
                <div className='adm-form'>
                  <div className='adm-form-group'>
                    <label className='adm-label adm-label-req'>Label (display text)</label>
                    <input className='adm-input' value={form.label} onChange={field('label')} placeholder='e.g. Products' required />
                  </div>
                  <div className='adm-form-group'>
                    <label className='adm-label adm-label-req'>Link / href</label>
                    <input className='adm-input' value={form.href} onChange={field('href')} placeholder='/products  or  https://...' required />
                  </div>
                </div>
              </div>
              <div className='adm-modal-footer'>
                <button type='button' className='adm-btn adm-btn-ghost' onClick={close}>Cancel</button>
                <button type='submit' className='adm-btn adm-btn-primary'>{mode === 'add' ? 'Add' : 'Save'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavAdmin;
